import { makeStyles, withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import { fill } from '../../utils/contrastSvgAttributes';

export const useStyles = makeStyles(() => ({
  cardPreviewMenu: {
    display: 'flex',
    flexDirection: 'row',
    position: 'absolute',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    height: '45px',
    backgroundColor: '#FFFFFF',
    padding: '0px 10px 0px 5px',
    zIndex: 20,
    transition: '0.5s ease-in-out',
  },
  cardPreviewMenuIcon: {
    width: '22px',
    height: '22px',
    margin: '12px 10px',
    cursor: 'pointer',
  },
  cardPreviewMenuIconDisabled: {
    pathFill: '#757575',
    cursor: 'not-allowed',
    pointerEvents: 'all',
  },
  pipe: {
    margin: '6px 10px',
  },
  closeIcon: {
    position: 'relative',
    top: '10px',
    left: '5px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  customTooltip: {
    backgroundColor: '#2C2D3E',
  },
  customArrow: {
    color: '#2C2D3E',
  },
  disabledAction: {
    position: 'absolute',
    top: '8px',
    left: '8px',
    height: '25%',
    width: '25%',
    color: 'black'
  },
}));

export const ZoomInput = withStyles((theme) => ({
  root: {
    position: 'relative',
    left: '15x',
    top: '6px',

    'label + &': {
      marginTop: theme.spacing(3),
    },

    '& .MuiSelect-icon': {
      width: '20px',
      height: '20px',
      top: '7px',
      color: fill
    },
  },
  input: {
    width: '40px',
    height: '20px',
    borderRadius: 3,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #ced4da',
    fontSize: 14,
    padding: '6px 20px 3px 5px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: 'Roboto',
    '&:focus': {
      border: '2px solid #ced4da',
      borderRadius: 3,
    },
  },
}))(InputBase);
